import { useEffect } from "react"

// Fix responsive (2026-08-14): react-signature-canvas fija canvasProps.width
// como resolución REAL del <canvas>, no solo un tamaño CSS — en un celular
// más angosto que eso, el canvas desbordaba su contenedor. No alcanza con un
// `width:'100%'` en CSS: signature_pad mapea los toques con
// canvas.getBoundingClientRect() (tamaño CSS) pero dibuja sobre la
// resolución interna del canvas — si difieren, el trazo aparece desplazado
// de donde tocás. Hay que igualar canvas.width/height (la resolución real)
// al tamaño CSS ya resuelto (canvas.offsetWidth) en cada resize, igual que
// recomienda la librería subyacente (signature_pad) para canvases
// responsive. clear() es necesario tras reescalar (mismo motivo que el
// clearOnResize por default de la librería): con isEmpty()/toDataURL() ya no
// corresponden con el bitmap real una vez cambiada la resolución.
//
// Extraído de Prescription.js a un hook aparte específicamente para poder
// testearlo sin tener que montar todo ese componente (decenas de hooks
// propios) ni lidiar con que react-signature-canvas no monta bajo jsdom sin
// el paquete `canvas` (getContext('2d') da null ahí).
export default function useCanvasResize(canvasRef, active) {
  useEffect(() => {
    if (!active) return
    const canvas = canvasRef.current?.getCanvas?.()
    if (!canvas) return
    const resize = () => {
      const ratio = Math.max(window.devicePixelRatio || 1, 1)
      const width = canvas.offsetWidth * ratio
      const height = canvas.offsetHeight * ratio
      // Bug real (auditoría 2026-08-16): cualquier evento 'resize' de window
      // (p.ej. el navegador mobile mostrando/ocultando la barra de
      // direcciones al scrollear, que dispara 'resize' sin que el tamaño
      // usable del canvas cambie) reescalaba y hacía clear() de la firma en
      // curso. Si las dimensiones calculadas son las mismas que ya tiene el
      // canvas, no hay nada que reescalar — evita borrar una firma a mitad
      // de trazo por un resize espurio.
      if (canvas.width === width && canvas.height === height) return
      canvas.width = width
      canvas.height = height
      canvas.getContext("2d").scale(ratio, ratio)
      canvasRef.current?.clear?.()
    }
    resize()
    window.addEventListener("resize", resize)
    return () => window.removeEventListener("resize", resize)
  }, [canvasRef, active])
}
